var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useRef } from 'react';
import './column.scss';
import { AonCheckbox } from '../../../../components/core/AonCheckbox';
import { AonTooltip } from '../../../../components/core/AonTooltip';
import { faCircleInfo, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useClientPageStore, useErrorStore } from '../../../../store';
import { Link, useNavigate } from 'react-router-dom';
import { UuiFlexlayout } from '@aonunited/react';
var ColumnTitle;
(function (ColumnTitle) {
    ColumnTitle["Selected_Market"] = "Selected Market(s)";
    ColumnTitle["Aon_ID"] = "Aon ID";
    ColumnTitle["Name_and_Group"] = "Name & Group";
    ColumnTitle["Domiciled_Country"] = "Domiciled Country";
    ColumnTitle["Status"] = "Status";
    ColumnTitle["Reinsurance_Indicator"] = "Reinsurance Indicator";
    ColumnTitle["Market_security_Brief"] = "Market Security Brief";
    ColumnTitle["Permitted_Use"] = "Permitted Use";
    ColumnTitle["AM_Best_Rating_and_Outlook"] = "AM Best Rating & Outlook";
    ColumnTitle["S_and_P_Rating_and_Outlook"] = "S&P Rating & Outlook";
    ColumnTitle["Additional_Rating_Information"] = "Additional Rating Information";
    ColumnTitle["PHS_ASHF_C_and_S_Capacity_AuM_USDmn"] = "PHS/ASHF/C&S/Capacity(USDmn)";
    ColumnTitle["Fact_Sheet"] = "Fact Sheet";
})(ColumnTitle || (ColumnTitle = {}));
export var columns = function (onSelected, apiLoading, sortColumn, sortBy, handleSorting) {
    var NameAndGroupCell = function (info) {
        var cellContentRef = useRef(null);
        useEffect(function () {
            if (cellContentRef.current && info.setTooltip) {
                var contentElement_1 = cellContentRef.current;
                var shouldDisplayTooltip = function () {
                    // return true
                    return contentElement_1.offsetWidth < contentElement_1.scrollWidth;
                };
                info.setTooltip(info.value, shouldDisplayTooltip);
            }
        }, [info.value, info.setTooltip]);
        var rowData = info.data;
        var navigationLink = "/market-details?MarketId=" + (rowData === null || rowData === void 0 ? void 0 : rowData.marketId);
        return (React.createElement(Link, { to: navigationLink, target: '_blank' },
            React.createElement("div", { ref: cellContentRef, className: 'text-ellipse' },
                React.createElement("span", { className: 'groupTextDecoration' }, info.getValue()),
                React.createElement("span", { style: { color: 'grey', display: "block" } }, rowData === null || rowData === void 0 ? void 0 : rowData.groupName))));
    };
    var MarketGuideStatus = function (info) {
        var val = info.getValue();
        var rowData = info.data;
        var doNotUseFlag = rowData === null || rowData === void 0 ? void 0 : rowData.doNotUseFlag;
        return (val === "Off" ?
            React.createElement("span", { style: { color: "red" } }, info.getValue()) :
            val === "Restricted" && doNotUseFlag ?
                React.createElement("span", { style: { color: "red" } }, "Do Not Use")
                :
                    React.createElement("span", null, info.getValue()));
    };
    var PermittedUse = function (info) {
        return (React.createElement("span", null, React.createElement(AonTooltip, { text: info.getValue(), width: 'md', darkMode: false, position: 'left', children: "".concat(info.getValue()) })));
    };
    var BestRatingCell = function (info) {
        var rowData = info.data;
        return (React.createElement("div", { className: 'cell-height', style: { textAlign: "center" } },
            info.getValue(),
            React.createElement("div", { style: { color: 'grey' } },
                " ", rowData === null || rowData === void 0 ? void 0 :
                rowData.ratingOutlook)));
    };
    var SAndPRating = function (info) {
        var rowData = info.data;
        return (React.createElement("div", { className: 'cell-height', style: { textAlign: "center" } },
            info.getValue(),
            React.createElement("div", { style: { color: 'grey' } },
                " ", rowData === null || rowData === void 0 ? void 0 :
                rowData.sAndPRatingOutlook)));
    };
    var AMBestRatingExplaination = function (info) {
        var rowData = info.data;
        var displayFlag = !(rowData === null || rowData === void 0 ? void 0 : rowData.amBestId) && !(rowData === null || rowData === void 0 ? void 0 : rowData.amBestRatingDate) && !(rowData === null || rowData === void 0 ? void 0 : rowData.amBestRatingExplanation) &&
            !(rowData === null || rowData === void 0 ? void 0 : rowData.sAndPId) && !(rowData === null || rowData === void 0 ? void 0 : rowData.sAndpRatingDate) && !(rowData === null || rowData === void 0 ? void 0 : rowData.sAndpRatingExplanation);
        return (!displayFlag ? React.createElement(FontAwesomeIcon, { style: { marginTop: "8px" }, className: 'info-icon', icon: faCircleInfo }) : React.createElement(React.Fragment, null));
    };
    var SurplusValueCell = function (info) {
        var rowData = info.data;
        var AddLocalSeparator = function (no) {
            return no.toLocaleString(undefined, {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            });
        };
        return (React.createElement(UuiFlexlayout, { direction: 'column', className: 'cell-height' }, info.getValue() ?
            React.createElement(React.Fragment, null,
                React.createElement("div", null, AddLocalSeparator(info.getValue())),
                React.createElement("div", { style: { color: 'grey' } },
                    " ", rowData === null || rowData === void 0 ? void 0 :
                    rowData.keyFinancialAsOfDate))
            : null));
    };
    var FactSheetDocCell = function (info) {
        var appInfo = useClientPageStore();
        var value = info.getValue();
        var errorStore = useErrorStore();
        var navigation = useNavigate();
        return value ? React.createElement("span", { onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                var err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, appInfo.handlePdfDownload(value)];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            errorStore.showError({ message: "Error", code: "500" });
                            navigation('/error');
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); } },
            React.createElement(FontAwesomeIcon, { style: { fontSize: "16px", color: "red", cursor: "pointer" }, icon: faFilePdf })) : null;
    };
    var SelectedMarketCell = function (info) {
        var rowData = info.data;
        var style = info.node.rowHeight === 30 ? { marginTop: "3px" } : { marginTop: "12px" };
        var isCellDisabled = rowData === null || rowData === void 0 ? void 0 : rowData.isSelectionDisabled;
        return (React.createElement("div", null,
            React.createElement(AonCheckbox, { style: style, disabled: isCellDisabled, onClick: function (event) { return onSelected(info.node.rowIndex, event); }, checked: rowData === null || rowData === void 0 ? void 0 : rowData.isActive })));
    };
    var AdvaisoryDocId = function (info) {
        var rowData = info.data;
        var advisoryFlagVal;
        ((rowData === null || rowData === void 0 ? void 0 : rowData.advisoryFlag) === true) ? advisoryFlagVal = "Yes" : advisoryFlagVal = "None";
        var clientStore = useClientPageStore();
        var isActive = advisoryFlagVal === "Yes" && (rowData === null || rowData === void 0 ? void 0 : rowData.advisoryDocGuid);
        var errorStore = useErrorStore();
        var navigation = useNavigate();
        var DownLoadPDF = function (value) { return __awaiter(void 0, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, clientStore.handlePdfDownload(value)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        errorStore.showError({ message: "Error", code: "500" });
                        navigation('/error');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: isActive ? 'groupTextDecoration' : "", onClick: isActive ? function () { return DownLoadPDF(rowData === null || rowData === void 0 ? void 0 : rowData.advisoryDocGuid); } : undefined }, advisoryFlagVal)));
    };
    var CountryCell = function (info) {
        return React.createElement("span", null, info.getValue());
    };
    var headerConfig = function (headerProps) {
        var classsName = sortColumn === headerProps.column.colId ? "sorting-".concat(sortBy, " active sorting-height") : "sorting sorting-height";
        return (React.createElement("div", { onClick: function () { return apiLoading ? null : handleSorting(headerProps.column.colId); }, className: classsName },
            React.createElement("span", null, headerProps.displayName)));
    };
    var CenterAlline = {
        display: "flex",
        justifyContent: "center"
    };
    return ([
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "Selected_Market", cellRenderer: SelectedMarketCell, headerName: ColumnTitle.Selected_Market, sortable: false, flex: 0.5, minWidth: 100 },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "marketId", headerName: ColumnTitle.Aon_ID, headerComponent: headerConfig, sortable: false, flex: 0.4, minWidth: 80 },
        { field: "name", headerName: ColumnTitle.Name_and_Group, headerComponent: headerConfig, tooltipField: "name", tooltipComponent: "MarKetNameTooltip", sortable: false, flex: 2.5, minWidth: 150, cellRenderer: NameAndGroupCell },
        { field: "countryName", cellRenderer: CountryCell, headerName: ColumnTitle.Domiciled_Country, sortable: false, flex: 0.75, minWidth: 120 },
        { field: "marketGuideStatus", cellRenderer: MarketGuideStatus, headerName: ColumnTitle.Status, sortable: false, flex: 0.75, minWidth: 110 },
        { field: "reinsuranceIndicator", headerName: ColumnTitle.Reinsurance_Indicator, sortable: false, flex: 0.75, minWidth: 150 },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "advisoryDocGuid", cellRenderer: AdvaisoryDocId, headerName: ColumnTitle.Market_security_Brief, sortable: false, flex: 0.65, minWidth: 100 },
        { field: "permittedUse", cellRenderer: PermittedUse, headerName: ColumnTitle.Permitted_Use, sortable: false, flex: 2, minWidth: 200 },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "bestRating", cellRenderer: BestRatingCell, headerName: ColumnTitle.AM_Best_Rating_and_Outlook, sortable: false, flex: 0.75, minWidth: 120 },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "sandPRating", cellRenderer: SAndPRating, headerName: ColumnTitle.S_and_P_Rating_and_Outlook, sortable: false, flex: 0.75, minWidth: 120 },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "amBestRatingExplanation", tooltipComponent: "AdditionalInfoTooltip", tooltipField: "name", cellRenderer: AMBestRatingExplaination, headerName: ColumnTitle.Additional_Rating_Information, sortable: false, flex: 0.75, minWidth: 120 },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "surplusValue", cellRenderer: SurplusValueCell, headerName: ColumnTitle.PHS_ASHF_C_and_S_Capacity_AuM_USDmn, sortable: false, flex: 1, minWidth: 150 },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, tooltipField: "factSheetDate", tooltipComponent: "tooltipComponent", field: "factSheetDocumentGuid", cellRenderer: FactSheetDocCell, headerName: ColumnTitle.Fact_Sheet, sortable: false, flex: 0.70, minWidth: 100 },
    ]);
};
export var GetRowHeight = function (params) {
    if (params.data.groupName && params.data.name) {
        return 50;
    }
    else if (params.data.ratingOutlook && params.data.bestRating) {
        return 50;
    }
    else if (params.data.sandPRating && params.data.sAndPRatingOutlook) {
        return 50;
    }
    else if (params.data.keyFinancialAsOfDate) {
        return 50;
    }
    else {
        return 30;
    }
};
